<template>
  <div>
    <b-container v-if="isLoading" class="text-center d-flex justify-content-center">
      <b-form>
        <br><br><br>
        <h5>{{ translate("loading") }}</h5>
        <br>
        <b-spinner style="color: rgb(109,122,82) !important"
          variant="warning"
        ></b-spinner>
      </b-form>
    </b-container>
    <div v-else>
      <b-container fluid style="padding:0">
        <p class="w-title" style="text-align: center">{{ translate("Welcome") }} {{ user.firstname }} {{ user.lastname }}, </p>
        <div class="w-youtube">
          <div class="youtube-responsive">
            <iframe
              :src="youtubeUrl"
              title="WyneCellar Getting Started"
              frameborder="0"
              allow="autoplay; encrypted-media; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        </div>
        <div>
          <p class="w-text" style="text-align: center;">{{ translate("Thank you for joining WyneCellar. Your wine journey starts here.") }}</p>
          <p class="w-text" style="text-align: center;">{{ translate("We're delighted to help you organize, manage and enjoy your wine collection.") }}</p>

          <p class="w-text" style="text-align: center;">{{ translate("To get started, watch the short introduction video above and create your first cellar.") }}</p>
          <p class="w-text" style="text-align: center;">{{ translate("In just a few minutes, you'll be ready to create units and add your wines, track your inventory and explore your collection.") }}</p>

          <p class="w-text" style="text-align: center;">{{ translate("Enjoy your wine journey!") }}</p>
          <br>
          <p class="w-subtitle" style="text-align: center;">{{ translate("The WyneLover Team") }}</p>
        </div>

        <div style="text-align:center">
          <b-button v-on:click="gotoStart()" class="w-button-green">start</b-button>
          <br>
          <br>
          <b-form-checkbox 
            id="showToggle"
            v-model="user.showWelcome"
          >
          <p class="w-label" style="text-align: center;" for="showToggle">{{ translate("show this page again") }}</p>        
          </b-form-checkbox>
        </div>
      </b-container>
      <!-- <NoAccess v-else></NoAccess> -->
    </div>
  </div>
</template>

<script>
  import {wordlist,translate_word} from '../assets/js/translate.js';
  import NoAccess from './NoAccess.vue';

  import Cookies from 'js-cookie';

  import Users from '../Users.js';

  export default {
    name: "Welcome",
    components:{
      NoAccess,
    },
    computed : {
      inSession() {
        return this.$store.state.inSession
      },
      currentUserID() {
        return this.$store.state.user_id
      },
      currentUser() {
        return this.$store.state.user
      },
      currentLanguage() {
        return this.$store.state.language
      },
      youtubeUrl() {
        const lang = Cookies.get('wynelover.language') || "en"

        if (lang === "en") {
          return "https://www.youtube.com/embed/_m1dh4eHLaI?autoplay=1&mute=1";
        }

        console.log("lang = ", lang)

        return `https://www.youtube.com/embed/_m1dh4eHLaI?autoplay=1&mute=1&cc_load_policy=1&cc_lang_pref=${lang}&hl=en`;
      }
    },
    data() {
      return {
        debug : false,
        isLoading : true,
        
        isValid : true,
      }
    }, 
    async mounted() {
      this.user_id = this.currentUserID
      this.user = this.currentUser
      this.isLoading = false
    },
    methods: {
      async gotoStart() {
        await Users.update(this.user_id,this.user)
        .then(response => {
          if (this.debug) console.log("Welcome.mounted: User ", response , " succesfully updated!")
          this.$store.commit('setUser',this.user)
        })
        .catch(error => {
          if (this.debug) console.log("Welcome.mounted: Catch is await Users error:", error)
        })

        try {
          this.$store.commit('setUser',this.user)
          this.$store.commit('setUserID',this.user_id)
        } catch(err) {
          alert("Welcome.mounted : Catch this.$store.commit ", err)
        }

        this.$store.commit('setPage','Dashboard')
        this.$router.push({path:'/Dashboard', query: {cellar_id:this.user.cellar_id }} );
      },

      translate(string) {
        return translate_word(string, this.currentLanguage);
      },

      translate_language(string, language) {
        return translate_word(string, language);
      },
    },
  }    
</script>

<style>
@import url("../assets/styles/wynestyle.css");
</style>

<style scoped>
.welcome-picture {
    width:100%;
    height:auto;
    
    background-image: url("../assets/img/welcome-cellar 2.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;

    position:relative;
}
.welcome-overlay {
  position: relative;
  top: 5vh;
}

.w-youtube {
  width: 80%;
  max-width: 1000px;
  margin: 2rem auto;

  border: 2px solid rgb(195,147,130);
  border-radius: 12px;
  overflow: hidden;

  background: #faf8f6;

  box-shadow:
    0 4px 12px rgba(0,0,0,0.15),
    0 12px 30px rgba(0,0,0,0.10);
}

.w-youtube:hover {
  transform: translateY(-2px);

  box-shadow:
    0 8px 20px rgba(0, 0, 0, 0.18),
    0 18px 40px rgba(0, 0, 0, 0.12);
}

.youtube-responsive {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
}

.youtube-responsive iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
</style> 